import { render, staticRenderFns } from "./BagItemChipsAndSalsa.vue?vue&type=template&id=1b1b67ea"
import script from "./BagItemChipsAndSalsa.vue?vue&type=script&lang=js"
export * from "./BagItemChipsAndSalsa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports